import {
  ExtraExtraAttributes,
  ProductShortSpecDisks,
  ProductShortSpecTyres,
  ProductSpecAkb,
  ProductSpecCode,
  ProductSpecDisks,
  ProductSpecOils,
  ProductSpecTyres,
} from '../../types/productSchema';

const typeDisk = ['Штампованные', 'Литые', 'Кованые', 'Грузовые'];
export const typeDiskLink = ['/catalog/discs/shtampov/', '/catalog/discs/litye/', '/catalog/discs/kovanye/', '/catalog/discs/trucks/'];

const BrandClassMapValue = {
  0: '-',
  1: 'Премиум',
  2: 'Средние по цене',
  3: 'Эконом',
  4: 'Бюджет',
};

export const conversionValue = (code, value): string => {
  switch (code) {
    case ProductSpecCode.Homologation:
      return value;
    case ProductSpecCode.RunFlat:
      return parseInt(value) ? 'Да' : 'Нет';
    case ProductSpecCode.Spikes:
      return parseInt(value) ? 'Шипованные' : 'Нешипованные';
    case ProductSpecCode.Season:
      return parseInt(value) ? 'Зимние' : 'Летние';
    case ProductSpecCode.DiskType:
      return typeDisk[value];
    case ProductSpecCode.AkbPolarity:
      return parseInt(value) ? 'Прям.' : 'Обрат.';
    case ProductSpecCode.AkbLength:
    case ProductSpecCode.AkbHeight:
    case ProductSpecCode.AkbWidth:
      return value + ' мм.';
    case ProductSpecCode.AkbCapacity:
      return value + ' Ah';
    case ProductSpecCode.BrandClass:
      return BrandClassMapValue[value] || '';
    default:
      return value;
  }
};

export const conversionSpecValue = (code, value): string => {
  switch (code) {
    case ProductSpecCode.RunFlat:
      return parseInt(value) ? 'Да' : 'Нет';
    case ProductSpecCode.Spikes:
      return parseInt(value) ? 'Шипованные' : 'Нешипованные';
    case ProductSpecCode.Season:
      return parseInt(value) ? 'Зимние' : 'Летние';
    case ProductSpecCode.DiskType:
      return typeDisk[value];
    case ProductSpecCode.AkbPolarity:
      return parseInt(value) ? 'Прям.' : 'Обрат.';
    case ProductSpecCode.AkbLength:
    case ProductSpecCode.AkbHeight:
    case ProductSpecCode.AkbWidth:
      return value + ' мм.';
    case ProductSpecCode.AkbCapacity:
      return value + ' Ah';
    default:
      return value;
  }
};

export const ProductSpecTitle = {
  [ProductSpecCode.Width]: ProductSpecTyres.Width,
  [ProductSpecCode.Height]: ProductSpecTyres.Height,
  [ProductSpecCode.Diameter]: ProductSpecTyres.Diameter,
  [ProductSpecCode.Season]: ProductSpecTyres.Season,
  [ProductSpecCode.Spikes]: ProductSpecTyres.Spikes,
  [ProductSpecCode.LoadIndex]: ProductSpecTyres.LoadIndex,
  [ProductSpecCode.SpeedIndex]: ProductSpecTyres.SpeedIndex,
  [ProductSpecCode.Homologation]: ProductSpecTyres.Homologation,
  [ProductSpecCode.ManufacturerCode]: ProductSpecTyres.ManufacturerCode,
  [ProductSpecCode.RunFlat]: ProductSpecTyres.RunFlat,
  [ProductSpecCode.Loads]: ProductSpecTyres.Loads,
  [ProductSpecCode.TypeAuto]: ProductSpecTyres.TypeAuto,
  [ProductSpecCode.StandardFactory]: 'Гарантия',
  [ProductSpecCode.BackProduct]: 'Возврат',
  [ProductSpecCode.SellerCode]: 'Код',

  [ProductSpecCode.TruckTyresWidth]: ProductShortSpecTyres.Width,
  [ProductSpecCode.TruckTyresHeight]: ProductShortSpecTyres.Height,
  [ProductSpecCode.TruckTyresDiam]: ProductShortSpecTyres.Diameter,
  [ProductSpecCode.TruckTyresLoad]: ProductShortSpecTyres.LoadIndex,
  [ProductSpecCode.TruckTyresSpeed]: ProductShortSpecTyres.SpeedIndex,
  [ProductSpecCode.TruckTyresAxle]: ProductShortSpecTyres.Axle,
  [ProductSpecCode.TruckTyresType]: ProductShortSpecTyres.Type,
  [ProductSpecCode.TruckTyresLayer]: ProductShortSpecTyres.Layer,

  [ProductSpecCode.DiskWidth]: ProductSpecDisks.Width,
  [ProductSpecCode.DiskRadius]: ProductSpecDisks.Diameter,
  [ProductSpecCode.DiskPcde]: ProductSpecDisks.PCD,
  [ProductSpecCode.DiskUnitedPcd]: ProductSpecDisks.PCD,
  [ProductSpecCode.DiskEt]: ProductSpecDisks.ET,
  [ProductSpecCode.DiskDia]: ProductSpecDisks.DIA,
  [ProductSpecCode.DiskType]: ProductSpecDisks.Type,
  [ProductSpecCode.DiskColor]: ProductSpecDisks.Color,

  [ProductSpecCode.AkbWidth]: ProductSpecAkb.Width,
  [ProductSpecCode.AkbHeight]: ProductSpecAkb.Height,
  [ProductSpecCode.AkbLength]: ProductSpecAkb.Length,
  [ProductSpecCode.AkbCapacity]: ProductSpecAkb.Capacity,
  [ProductSpecCode.AkbPolarity]: ProductSpecAkb.Polarity,
  [ProductSpecCode.AkbCranking]: ProductSpecAkb.Cranking,

  [ProductSpecCode.Size]: ExtraExtraAttributes.Size,
  [ProductSpecCode.Brand]: ExtraExtraAttributes.Brand,
  [ProductSpecCode.Model]: ExtraExtraAttributes.Model,
  [ProductSpecCode.Country]: ExtraExtraAttributes.Country,
  [ProductSpecCode.BrandClass]: ExtraExtraAttributes.BrandClass,
  [ProductSpecCode.ExtendedWarranty]: ExtraExtraAttributes.ExtendedWarranty,

  [ProductSpecCode.OilViscosity]: ProductSpecOils.Viscosity,
  [ProductSpecCode.OilVolume]: ProductSpecOils.Volume,
  [ProductSpecCode.OilApi]: ProductSpecOils.Api,
  [ProductSpecCode.OilAcea]: ProductSpecOils.Acea,
  [ProductSpecCode.OilType]: ProductSpecOils.Type,
  [ProductSpecCode.OilLimit]: ProductSpecOils.OilLimit,
};

export const ProductSpecShortTitle = {
  [ProductSpecCode.Width]: ProductShortSpecTyres.Width,
  [ProductSpecCode.Height]: ProductShortSpecTyres.Height,
  [ProductSpecCode.Diameter]: ProductShortSpecTyres.Diameter,
  [ProductSpecCode.Season]: ProductShortSpecTyres.Season,
  [ProductSpecCode.Spikes]: ProductShortSpecTyres.Spikes,
  [ProductSpecCode.LoadIndex]: ProductShortSpecTyres.LoadIndex,
  [ProductSpecCode.SpeedIndex]: ProductShortSpecTyres.SpeedIndex,
  [ProductSpecCode.Homologation]: ProductShortSpecTyres.Homologation,
  [ProductSpecCode.ManufacturerCode]: ProductShortSpecTyres.ManufacturerCode,
  [ProductSpecCode.RunFlat]: ProductShortSpecTyres.RunFlat,
  [ProductSpecCode.Loads]: ProductShortSpecTyres.Loads,
  [ProductSpecCode.StandardFactory]: 'Гарантия',
  [ProductSpecCode.BackProduct]: 'Возврат',
  [ProductSpecCode.SellerCode]: 'Код',

  [ProductSpecCode.TruckTyresWidth]: ProductShortSpecTyres.Width,
  [ProductSpecCode.TruckTyresHeight]: ProductShortSpecTyres.Height,
  [ProductSpecCode.TruckTyresDiam]: ProductShortSpecTyres.Diameter,
  [ProductSpecCode.TruckTyresAxle]: ProductShortSpecTyres.Axle,
  [ProductSpecCode.TruckTyresType]: ProductShortSpecTyres.Type,

  [ProductSpecCode.DiskWidth]: ProductShortSpecDisks.Width,
  [ProductSpecCode.DiskRadius]: ProductShortSpecDisks.Diameter,
  [ProductSpecCode.DiskPcde]: ProductShortSpecDisks.PCD,
  [ProductSpecCode.DiskUnitedPcd]: ProductShortSpecDisks.PCD,
  [ProductSpecCode.DiskEt]: ProductShortSpecDisks.ET,
  [ProductSpecCode.DiskDia]: ProductShortSpecDisks.DIA,
  [ProductSpecCode.DiskType]: ProductSpecDisks.Type,
  [ProductSpecCode.DiskColor]: ProductShortSpecDisks.Color,

  [ProductSpecCode.AkbWidth]: ProductSpecAkb.Width,
  [ProductSpecCode.AkbHeight]: ProductSpecAkb.Height,
  [ProductSpecCode.AkbLength]: ProductSpecAkb.Length,
  [ProductSpecCode.AkbCapacity]: ProductSpecAkb.Capacity,
  [ProductSpecCode.AkbPolarity]: ProductSpecAkb.Polarity,

  [ProductSpecCode.OilViscosity]: ProductSpecOils.Viscosity,
  [ProductSpecCode.OilVolume]: ProductSpecOils.Volume,
  [ProductSpecCode.OilApi]: ProductSpecOils.Api,
  [ProductSpecCode.OilAcea]: ProductSpecOils.Acea,
  [ProductSpecCode.OilType]: ProductSpecOils.Type,
};

export const conversionTitle = (code: ProductSpecCode | ExtraExtraAttributes, shortTitle?: boolean): string => {
  return shortTitle ? ProductSpecShortTitle[code] : ProductSpecTitle[code];
};
